import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=4a06d006&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=4a06d006&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06d006",
  null
  
)

export default component.exports